export type ProspectStatus =
  | 'prospect'
  | 'deck_building'
  | 'deck_ready'
  | 'outreach_sent'
  | 'meeting_booked'
  | 'disqualified';

export const PROSPECT_STATUS_LABELS: Record<ProspectStatus, string> = {
  prospect: 'Prospect',
  deck_building: 'Deck Building',
  deck_ready: 'Deck Ready',
  outreach_sent: 'Outreach Sent',
  meeting_booked: 'Meeting Booked',
  disqualified: 'Disqualified',
};

export interface Prospect {
  id: string;

  // Core brand identity
  brand: string;
  website: string | null;
  category: string | null;
  product_type: string | null;
  estimated_aov: string | null;
  aov_confidence: string | null;
  likely_revenue_stage: string | null;
  revenue_confidence: string | null;
  channel_model: string | null;

  // Distribution
  dtc_presence: string | null;
  retail_presence: string | null;
  amazon_presence: string | null;
  target_presence: string | null;
  other_retail_partners: string | null;

  // Leadership
  founder_led_or_corporate: string | null;
  known_founder_or_ceo: string | null;
  known_marketing_leader: string | null;

  // Network
  sean_matched_contact: string | null;
  sean_contact_title: string | null;
  sean_contact_company: string | null;
  sean_connection_type: string | null;
  sean_connection_score: number | null;

  // Scores
  icp_fit_score: number | null;
  paid_media_opportunity_score: number | null;
  brand_quality_score: number | null;
  landability_score: number | null;
  final_priority_score: number | null;

  // Tiers
  priority_tier: string | null;
  classification_tier: string | null;

  // Ad research
  meta_ad_library_url: string | null;
  google_ads_transparency_url: string | null;
  ad_library_notes: string | null;
  observed_creative_themes: string | null;
  likely_paid_media_maturity: string | null;
  likely_paid_media_gap: string | null;

  // Opportunity analysis
  lifecycle_opportunity: string | null;
  landing_page_or_funnel_opportunity: string | null;
  retail_media_opportunity: string | null;
  why_xyz_could_win: string | null;
  why_this_brand_might_say_yes: string | null;
  suggested_outreach_angle: string | null;
  recommended_opener_path: string | null;
  validation_needed: string | null;
  confidence_level: string | null;
  exclude_reason: string | null;

  // Workflow
  status: ProspectStatus;
  notes: string | null;
  deck_url: string | null;
  source: string;

  created_at: string;
  updated_at: string;
}
